import React from "react";
import "./BracksetHeaderSimple.css";
import { navigateToLandingPage } from "utilities/js/NavigationHelper";
import { NavigatorWrapper } from "./NavigatorWrapper";
import Constants from "utilities/js/Constants";
// import { HistoryNavigator } from "./HistoryNavigator";

const LogoIcon = Constants.ICON_LOGO;

class BracksetHeaderSimple extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            
        };
        this.navigateToLandingPage = this.navigateToLandingPage.bind(this);

    }

    navigateToLandingPage(){
        // this.props.history.push("/");
        navigateToLandingPage({routerNav: this.props.navigate});
    }

    render() {
        
        return (<>
        
            <div className="brackset-header-simple-logo" onClick={this.navigateToLandingPage}>
                <div className="brackset-header-simple-logo-container">
                    <img className="brackset-header-simple-logo-icon" src={LogoIcon} alt="logo-icon"></img>
                    <div className="brackset-header-simple-logo-name">Brackset</div>
                </div>
                <div className="brackset-header-simple-logo-tagline">The worldwide leader in bracket generation</div>

            </div>
        </>)
    }
}

export default NavigatorWrapper(BracksetHeaderSimple);
